<template>
  <ProjectBaseView>
    <KanBan style="width: 100%;"/>
  </ProjectBaseView>
</template>

<script>
import KanBan from '@/components/pmo/KanBan.vue';
import ProjectBaseView from "./ProjectBaseView.vue";

export default {
  name: "ProjectKanban",
  components: {
    KanBan,
    ProjectBaseView,
  },
  computed: {
    project(){
      return this.$store.state.project || null;
    }
  },
}
</script>

<style scoped>

</style>